export const CHANGE_LANG = 'CHANGE_LANG';
export const SHOW_DEVELOP = 'SHOW_DEVELOP';
export const SET_ALERT = 'SET_ALERT';
export const SHOW_LOADING = 'SHOW_LOADING';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_PRODUCT_QUERY = 'SET_PRODUCT_QUERY';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_USER_MENUS = 'SET_USER_MENUS';
export const SET_FOOTER_MENUS = 'SET_FOOTER_MENUS';
export const SET_ALL_PAGES = 'SET_ALL_PAGES';
export const SET_LANGUAGES = 'SET_LANGUAGES';
